import { useTranslation } from 'next-i18next/pages';

import Carousel from '@shared/components/carousel/Carousel';
import { PostType } from '@shared/components/magazin/types';

import RelevantArticleCard from './RelevantArticleCard';

interface RelevantArticlesProps {
  posts?: PostType[];
  hideRelevantArticleTitle?: boolean;
  centered?: boolean;
  showFourGrids?: boolean;
  title?: string;
}

const RelevantArticles: React.FC<RelevantArticlesProps> = ({
  posts = [],
  hideRelevantArticleTitle = false,
  centered = false,
  showFourGrids = false,
  title,
}) => {
  const { t } = useTranslation('magazin');
  const heading = title ?? t('relevantArticlesHeading');

  return (
    <>
      {!hideRelevantArticleTitle && <h3 className='mb-4 text-base font-semibold md:text-xl'>{heading}</h3>}
      <Carousel centered={centered} showFourGrids={showFourGrids}>
        {posts.map(post => (
          <RelevantArticleCard key={post.id} post={post} />
        ))}
      </Carousel>
    </>
  );
};

export default RelevantArticles;
